<div class="page-container">
  @if (pageLoading) {
    <app-loading-modal [content]="'loading styles'"></app-loading-modal>
  }
  <div class="background-container"></div>
  <div class="content-container">
    <div class="bread-crumbs-container" (click)="goBack()">
      <a href="javascript:"><img src="assets/cb/images/chevron-left-grey.svg" alt="" /> Go Back</a>
    </div>
    <div class="page-title">
      <h1><img class="web-tab-only" src="assets/cb/images/step-2-icon.png" alt="" />
        @if (uploadDesign == false) {
          <span>Select a Style</span>
        }
        @if (uploadDesign == true) {
          <span>Upload Design: Select a Style</span>
        }</h1>
      </div>
      <div class="page-content">
        <!-- web-tab-only -->
        @if (!failedcategories) {
          <div class="row web-tab-only">
            @for (subcategory of subcategories; track trackByFn(i, subcategory); let i = $index) {
              <div class="product-container col-lg-3 col-xs-8" [attr.data-testid]="subcategory.code">
                <div class="product-content">
                  <div class="image-container col-xs-12"
                    [routerLink]="['/box-options', categoryCode, subcategory.code, uploadDesign]"
                    [ngStyle]="{background: 'url(&quot;' + getDefaultPicture(subcategory) + '&quot;)'}"
                    (mouseover)="showGIF($event.target, subcategory)"
                    (mouseleave)="showStaticPicture($event.target, subcategory)">
                  </div>
                  <div class="product-header">
                    <div [innerHTML]="subcategory.name"></div>
                  </div>
                  <div class="product-description" [innerHTML]="subcategory?.data[0]?.value"></div>
                  <div class="button-container">
                    <div [routerLink]="['/box-options', categoryCode, subcategory.code, uploadDesign]"
                      class="link-container chevron-anchor red border">
                      @if (categoryCode !== 'Other Products') {
                        <a>Build</a>
                      }
                      @if (categoryCode === 'Other Products') {
                        <a>Design</a>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <!-- mobile-only -->
        @if (!failedcategories) {
          <div class="mobile-only carousel-container">
            @for (subcategory of subcategories; track trackByFn(i, subcategory); let i = $index) {
              <div class="carousel-item"
                [ngClass]="{'hidden-right': ((this.shownCategory + 1) < i), 'hidden-left': (i < (this.shownCategory - 1)), 'left-item': (i < (this.shownCategory)), 'right-item': ((this.shownCategory) < i)}">
                <div class="image-container col-xs-12"
                  [routerLink]="['/box-options', categoryCode, subcategory.code, uploadDesign]">
                  <img [src]="getDefaultPicture(subcategory)" (mouseover)="showGIF($event.target, subcategory)"
                    (mouseleave)="showStaticPicture($event.target, subcategory)">
                </div>
                <div class="product-header">
                  <div [innerHTML]="subcategory.name"></div>
                </div>
                <div class="product-description" [innerHTML]="subcategoryDescriptions[i]"></div>
                <div class="button-container">
                  <div [routerLink]="['/box-options', categoryCode, subcategory.code, uploadDesign]"
                    class="link-container chevron-anchor red border">
                    <a class="web-tab-only">Build</a>
                    <a class="mobile-only">Select</a>
                  </div>
                </div>
              </div>
            }
            <div class="chevron-container">
              <button class="chevron-button" [ngClass]="{'disabled': (this.shownCategory === 0)}"
                [ngStyle]="{background: 'url(assets/cb/images/round_chevron_left.svg)'}" (click)="previousCategory()">
              </button>
              <button class="chevron-button"
                [ngClass]="{'disabled': ((this.shownCategory + 1) === (this.subcategories.length))}"
                [ngStyle]="{background: 'url(assets/cb/images/round_chevron_right.svg)'}" (click)="nextCategory()">
              </button>
            </div>
          </div>
        }
        <!---------->
      </div>
    </div>
  </div>

  <ng-template #notFoundModal>
    <app-not-found-modal></app-not-found-modal>
  </ng-template>
